<template>
  <div>
    <div v-if="!dialogVisibleDetail" class="commodityManage div-layout">
      <module-title title="账户余量" />
      <div>
        <el-table
          v-loading="listLoading"
          :data="accountbalancesList"
          highlight-current-row
          fit
          element-loading-text="Loading"
          class="list-table"
        >
          <el-table-column type="index" width="105" align="center" label="序号" />
          <el-table-column label="厂商" prop="name" align="left" />
          <el-table-column label="账户剩余" prop="itemList" align="left">
            <template slot-scope="scope">
              <div v-for="(v,index) in scope.row.itemList" :key="index">
                {{ v.name }}：{{ v.value }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="300px">
            <template slot-scope="scope">
              <el-button
                v-show="scope.row.code==='M0003'"
                size="medium"
                type="primary"
                icon="el-icon-upload2"
                @click="improtExcel"
              >
                导入
              </el-button>
              <el-button
                v-show="scope.row.code==='M0003'"
                size="medium"
                type="primary"
                @click="handleDetail(scope.row)"
              >
                详情
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-dialog
        v-if="dialogVisibleImport"
        :close-on-click-modal="false"
        :visible.sync="dialogVisibleImport"
        title="导入"
        width="580px"
      >
        <div v-show="!resultPage" class="textCenter">
          <el-upload
            ref="upload"
            :on-success="onSuccess"
            :action="uploadUrl"
            :headers="uploadHeader"
            :on-progress="fileUploading = true"
            :on-error="onError"
            :before-upload="onBeforeUpload"
            :multiple="false"
            :limit="1"
            name="file"
            accept=".xls, .xlsx"
            :data="uploadSubmitData"
          >
            <div class="avatar-uploader">
              <i class="el-icon-plus avatar-uploader-icon" />
            </div>
            <span class="text">{{ !fileUploading ? '选择你要导入的文档':'导入【吃掉系列】会员授权码文档，excel文件，大小50M内' }}</span>
          </el-upload>
        </div>
        <div v-show="resultPage" class="resultPage">
          <div>导入数量：<span>{{ abnormalDataUpload.importRows }}</span></div>
          <div>
            异常数据：
            <span v-if="abnormalDataUpload.errorRows != 0">
              <span class="red" style="margin-right:10px">{{ abnormalDataUpload.errorRows }}</span>
              <a class="blue" @click="dialogVisibleImportAbnormal=true">查看详情</a>
            </span>
            <span v-else>{{ abnormalDataUpload.errorRows }}</span>
          </div>
          <div v-show="abnormalDataUpload.errorRows > 0 " class="red">
            无法导入！
          </div>
        </div>
        <div v-show="resultPage" slot="footer" class="dialog-footer">
          <el-button size="medium" @click="dialogVisibleImport = false">
            取消
          </el-button>
        </div>
      </el-dialog>
      <!-- 异常数据 -->
      <el-dialog
        :close-on-click-modal="false"
        :visible.sync="dialogVisibleImportAbnormal"
        title="异常数据"
      >
        <p style="padding:0 0 20px 20px;">
          导入失败，存在{{ abnormalDataUpload.errorRows }}条异常记录，请修改后重新上传
        </p>
        <el-scrollbar wrap-class="abnormal-table">
          <el-table
            :data="abnormalDataUpload.errorList"
            fit
            highlight-current-row
          >
            <el-table-column type="index" width="55" align="center" label="序号" />
            <el-table-column label="异常原因" prop="errorMsg" align="center">
              <template slot-scope="scope">
                <span class="red">{{ scope.row.errorMsg }}</span>
              </template>
            </el-table-column>
          </el-table>
        </el-scrollbar>
      </el-dialog>
    </div>
    <Detail
      v-if="dialogVisibleDetail"
      :visible.sync="dialogVisibleDetail"
      :detail-data="handleDetailFrom"
    />
  </div>
</template>

<script>
import { getToken } from '@/utils/auth';
import Detail from './detail';
import { getThirdaccountbalances, thirdaccountbalancesImprotExcel } from '@/api/userManagement/index';
import { mapGetters } from 'vuex';
export default {
  name: 'Thirdaccountbalances',
  components: {
    Detail
  },
  data() {
    return {
      dialogVisibleImportAbnormal: false,
      uploadSubmitData: {
        userCode: ''
      }, // 批量导入上传文件参数
      fileUploading: false, // 文件上传加载
      uploadUrl: '', // 上传文件URL
      uploadHeader: {
      }, // 上传文件上传头
      abnormalDataUpload: [], // 异常数据列表
      // 搜索表单
      searchForm: {
        pageNum: 1,
        pageSize: 10
      },
      accountbalancesList: [],
      listLoading: false, // 表格刷新loading
      dialogVisibleImport: false,
      dialogVisibleDetail: false,
      handleDetailFrom: {},
      resultPage: false
    };
  },

  computed: {
    ...mapGetters(['userInfo'])
  },
  mounted() {
    this.fetchAccountbalances();
    this.initUploadData();
  },
  methods: {
    // 初始化上传数据
    initUploadData() {
      const accessToken = getToken();
      this.uploadHeader = {
        Authorization: `Bearer ${accessToken}`
      };
      this.uploadSubmitData.userCode = this.userInfo.code ? this.userInfo.code : '';
      this.uploadUrl = thirdaccountbalancesImprotExcel();
    },
    // 获取积分明细数据
    fetchAccountbalances() {
      this.listLoading = true;
      var option = {
        pageNum: this.searchForm.pageNum,
        pageSize: this.searchForm.pageSize
      };
      getThirdaccountbalances(option).then((res) => {
        console.log(res);
        if (res.code === '0' && res.data) {
          this.accountbalancesList = res.data;
        } else {
          this.accountbalancesList = [];
        }
        this.listLoading = false;
      }).catch((err) => {
        console.log(err);
        this.accountbalancesList = [];
        this.listLoading = false;
      });
    },
    // 分页
    pageCurriculumList(obj) {
      this.searchForm.pageNum = obj.page;
      this.fetchAccountbalances();
    },
    // 分页条数变化
    handleSizeChange(obj) {
      this.searchForm.pageNum = 1;
      this.searchForm.pageSize = obj.limit;
      this.fetchAccountbalances();
    },
    // 导入 加载
    improtExcel() {
      this.dialogVisibleImport = true;
      this.resultPage = false;
      this.fileUploading = false;
      this.abnormalDataUpload = {};
    },
    // 导入上传成功
    onSuccess(response, file, fileList) {
      this.$refs.upload.clearFiles();
      if (response.code === '0') {
        this.$message({
          message: '文件上传成功',
          type: 'success'
        });
        this.abnormalDataUpload = response.data;
        this.fetchAccountbalances();
      } else {
        if (response.data) {
          this.abnormalDataUpload = response.data;
        } else {
          this.$message({
            message: response.message,
            type: 'error'
          });
          this.abnormalDataUpload = {};
        }
      }
      this.resultPage = true;
    },
    onBeforeUpload(e) {
      // 上传图片
      var file = e;
      if (!/\.(xls|xlsx)$/.test(file.name.toLowerCase())) {
        this.$message.error('导入【吃掉系列】会员授权码文档必须是excel文件');
        return false;
      } else if (file.size > 1024 * 1024 * 50) {
        this.$message.error('图片大小不超过50MB!');
        return false;
      }
    },
    // 导入上传失败
    onError() {
      this.$refs.upload.clearFiles();
      this.$message({
        message: '上传文件失败',
        type: 'error'
      });
    },
    handleDetail(row) {
      this.handleDetailFrom = row;
      this.dialogVisibleDetail = true;
    }
  }
};
</script>
<style lang="scss" scoped>
.commodityManage {
  padding-bottom: 20px;
}
.edit-form-input {
  width: 100px;
}
.avatar-uploader {
  font-size: 28px;
  color: #8c939d;
  line-height: 108px;
  width: 108px;
  height: 108px;
  margin: 0 auto;
  text-align: center;
  border: 1px dashed #d9d9d9;
}
.avatar-uploader:hover{
   border: 1px dashed #409EFF;
}
.textCenter .text{
  padding-top: 10px;
  display: inline-block;
}
.resultPage{
  line-height: 32px;
}
</style>
